/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum GlobalFilterListOrderValue {
    Description = 'Description',
    Comment = 'Comment',
    BrandAndMarket = 'BrandAndMarket',
    Channel = 'Channel',
    Relevance = 'Relevance'
}

export function GlobalFilterListOrderValueFromJSON(json: any): GlobalFilterListOrderValue {
    return GlobalFilterListOrderValueFromJSONTyped(json, false);
}

export function GlobalFilterListOrderValueFromJSONTyped(json: any, ignoreDiscriminator: boolean): GlobalFilterListOrderValue {
    return json as GlobalFilterListOrderValue;
}

export function GlobalFilterListOrderValueToJSON(value?: GlobalFilterListOrderValue | null): any {
    return value as any;
}

